import React from 'react';

import { formatMonetaryAmount } from 'utils/formatMonetaryAmount';
import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import FinancialCheckupNavigation from 'components/FinancialCheckup/FinancialDashboardNavigation';
import { FlowComponentType } from 'routes/types';

import styles from './PaymentDetail.module.scss';

export interface PaymentDetailRow {
  title: string;
  value: React.ReactNode;
}

interface PaymentDetailProps extends FlowComponentType {
  amount: number;
  detailRows: PaymentDetailRow[];
  isLoading: boolean;
  error?: string;
}

const PaymentDetail = ({ amount, detailRows, isLoading, error, navigationInfo }: PaymentDetailProps) => {
  if (isLoading || error) {
    return (
      <>
        <FinancialCheckupNavigation {...navigationInfo} />
        <div className={styles.content}>
          <p className={isLoading ? styles.message : styles.errorMessage}>{isLoading ? 'Loading...' : error}</p>
        </div>
      </>
    );
  }

  return (
    <>
      <FinancialCheckupNavigation {...navigationInfo} />
      <div className={styles.content}>
        <h1 className={styles.amount}>{formatMonetaryAmount(amount)}</h1>
        <ActionCard variant={ActionCardVariant.White} className={styles.card}>
          {detailRows.map((row) => (
            <div className={styles.section} key={row.title}>
              <p className={styles.label}>{row.title}</p>
              {typeof row.value === 'string' ? <p className={styles.value}>{row.value}</p> : row.value}
            </div>
          ))}
        </ActionCard>
      </div>
    </>
  );
};

export default PaymentDetail;
